var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentGuardian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.692,
    height: 42.038,
    viewBox: "0 0 39.692 42.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parent_Guardian",
    "data-name": "Parent/Guardian",
    transform: "translate(0 -18.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019",
    transform: "translate(0 26.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M12.992,109.31H4.012a3.959,3.959,0,0,0-3.951,3.931L0,125.506a1.67,1.67,0,0,0,1.661,1.678h.009a1.67,1.67,0,0,0,1.669-1.661L3.4,113.258v0a.331.331,0,0,1,.662,0v28.064a2,2,0,0,0,4.007,0V125.309h.865v16.013a2,2,0,0,0,4.007,0c0-26.482-.035-11.338-.036-28.04a.35.35,0,0,1,.7-.028h0l-.011,12.258a1.67,1.67,0,0,0,1.668,1.671h0a1.67,1.67,0,0,0,1.669-1.668l.011-12.265s0-.007,0-.01A3.959,3.959,0,0,0,12.992,109.31Z",
    transform: "translate(0 -109.31)",
    fill: "#3e3e3e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "translate(5.043 18.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    fill: "#3e3e3e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023",
    transform: "translate(18.98 26.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M298.846,123.894c-.031-.087-3.067-8.746-3.544-10.136-.769-2.237-2.058-3.372-3.832-3.372H285.7c-1.774,0-3.063,1.135-3.832,3.372-.478,1.39-3.513,10.049-3.544,10.136a1.657,1.657,0,0,0,3.128,1.1c.1-.279,1.924-5.354,2.943-8.274-.107.872.2-.937-2.369,12.329a.922.922,0,0,0,.9,1.1h1.265v12.021a1.989,1.989,0,0,0,3.977,0V130.142h.859v12.021a1.989,1.989,0,1,0,3.977,0V130.142h1.265a.921.921,0,0,0,.9-1.1c-2.546-13.145-2.265-11.619-2.352-12.329,1.027,2.942,2.8,8,2.9,8.274a1.657,1.657,0,1,0,3.128-1.1Z",
    transform: "translate(-278.227 -110.386)",
    fill: "#3e3e3e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025",
    transform: "translate(25.916 18.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2024",
    "data-name": "Group 2024",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 3.435,
    cy: 3.435,
    r: 3.435,
    fill: "#3e3e3e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentGuardian);
export default __webpack_public_path__ + "static/media/ParentGuardian.dbdd91ba7e1da5766940421ab124cc87.svg";
export { ForwardRef as ReactComponent };